// 📁 GameLobby.js
import React, { useEffect, useState } from "react";
import axios from "axios";
import socket from "../socket";
import { useNavigate } from "react-router-dom";

export default function GameLobby() {
  const [status, setStatus] = useState(null);
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();
  const [stats, setStats] = useState(null);
  const [myHunter, setMyHunter] = useState(null);
  const [endBanner, setEndBanner] = useState(null);
  const lastGame = JSON.parse(localStorage.getItem("lastGameResult") || "null");

  console.log("🔥 Lobby mounted, socket ID:", socket.id);

  // ======================================================
  // 🚀 STEP 1 — Identify IMMEDIATELY when socket connects
  // This fixes all real-time issues + target assignment + GPS
  // ======================================================
useEffect(() => {
  const handleConnect = async () => {
    console.log("⚡ Socket connected, sending identify...");

    try {
      const me = await axios.get("/api/me", { withCredentials: true });
	  setStats({
        wins: me.data.user.wins ?? 0,
        losses: me.data.user.losses ?? 0
        });
      const uid = me.data.user._id;

      console.log("🟢 IDENTIFYING AS:", uid);
      socket.emit("identify", uid);
	  console.log("📊 STATS FROM API:", me.data.user.wins, me.data.user.losses);

    } catch (err) {
      console.error("❌ Identification error:", err);
    }
  };

  socket.on("connect", handleConnect);

  return () => socket.off("connect", handleConnect);
}, []);

//Force logout
//useEffect(() => {
  //const handler = ({ reason }) => {
    //alert(`🚫 Logged out: ${reason}`);
    //window.location.href = "/"; // or /login
  //};

  //socket.on("forceLogout", handler);
  //return () => socket.off("forceLogout", handler);
//}, []);



  // ======================================================
  // 🚀 STEP 2 — Fetch approval status + join game room if approved
  // ======================================================

useEffect(() => {
  const init = async () => {
    try {
      const lastGameRaw = localStorage.getItem("lastGameResult");

      if (lastGameRaw) {
        const lastGame = JSON.parse(lastGameRaw);

        // 🔒 HARD BLOCK — winner OR loser
        if (Date.now() - lastGame.ts < 60_000) {
          console.log("🏁 Post-game lobby lock active");
          return;
        }
      }

      const res = await axios.get("/api/my-approval-status", {
        withCredentials: true,
      });

      const data = res.data;
      setStatus(data);

      // ☠️ Dead players never auto-enter map
      if (data.isAlive === false) return;

      if (data.approved && data.gameId) {
        socket.emit("joinGameRoom", data.gameId);
      }

      if (data.approved && data.gameStarted) {
        console.log("🚀 Redirecting to map");
        navigate("/map");
      }
    } catch (err) {
      console.error("❌ Lobby init error:", err);
    }
  };

  init();
}, [navigate]);



  // ======================================================
  // 🚀 STEP 3 — Real-time approval event
  // ======================================================
  useEffect(() => {
    const handleApproved = (payload) => {
      console.log("🔥 Real-time APPROVED:", payload);

      setStatus({
        approved: true,
        gameId: payload.gameId,
        gameName: payload.gameName,
        gameStarted: false,
        isAlive: true,
      });

      // Identify again to guarantee server association
      socket.emit("identify", payload.userId);

      // Join game room instantly
      socket.emit("joinGameRoom", payload.gameId);
    };

    socket.on("playerApproved", handleApproved);
    return () => socket.off("playerApproved", handleApproved);
  }, []);
  
  useEffect(() => {
  const raw = localStorage.getItem("lastGameResult");
  if (!raw) return;

  try {
    const data = JSON.parse(raw);

    // only show if recent (10s)
    if (Date.now() - data.ts < 10_000) {
      setEndBanner(data);
      setTimeout(() => setEndBanner(null), 6000);
    }
  } catch (e) {}

  // ✅ clear so it doesn’t persist forever
  setTimeout(() => {
  localStorage.removeItem("lastGameResult");
}, 60_000); // 1 minute safety window

}, []);

  //hunter ID
  useEffect(() => {
  const handler = ({ hunterId, hunterName }) => {
    setMyHunter({ hunterId, hunterName });
  };

  socket.on("hunterAssigned", handler);
  return () => socket.off("hunterAssigned", handler);
}, []);


  // ======================================================
  // 🚀 STEP 4 — Real-time game start event
  // ======================================================
useEffect(() => {
  const handleGameStarted = ({ gameId }) => {
    const lastGame = localStorage.getItem("lastGameResult");
    if (lastGame) {
      console.log("🛑 Ignoring gameStarted — post-game state");
      return;
    }

    console.log("📡 WS — Game started:", gameId);
    navigate("/map");
  };

  socket.on("gameStarted", handleGameStarted);
  return () => socket.off("gameStarted", handleGameStarted);
}, [navigate]);

  
  
  //Reconnect after wake
  useEffect(() => {
  if (!userId) return;

  const onConnect = () => {
    socket.emit("identify", userId);
    if (status?.gameId) socket.emit("joinGameRoom", status.gameId);
  };

  socket.on("connect", onConnect);
  return () => socket.off("connect", onConnect);
}, [userId, status?.gameId]);

  
  

  // ======================================================
  // UI
  // ======================================================
  if (!status) return <div>Checking status…</div>;

  return (
    <div style={{ padding: "20px" }}>
      <h2 className="text-xl font-bold">🎯 Game Lobby</h2>
	  {stats && (
  <div style={{
    marginTop: "12px",
    padding: "10px",
    background: "#111",
    borderRadius: "8px",
    color: "#fff",
    width: "fit-content"
  }}>
    <strong>📊 Your Stats</strong>
    <div>✅ Wins: {stats.wins}</div>
    <div>☠️ Losses: {stats.losses}</div>
  </div>
)}
{endBanner && (
  <div style={{
    background: "rgba(0,0,0,0.8)",
    color: "white",
    padding: "10px 14px",
    borderRadius: "10px",
    marginBottom: "12px",
    border: "2px solid gold"
  }}>
    {endBanner.iWon
      ? "🏆 YOU WIN!"
      : `🏆 Game Over — Winner: ${endBanner.winnerName}`}
  </div>
)}


      {!status.approved && <p>⏳ Waiting for admin approval…</p>}
	  {myHunter ? (
  <div style={{ marginTop: "10px", color: "#f87171", fontWeight: "bold" }}>
    👀 You will be hunted by: {myHunter.hunterName}
  </div>
) : (
  <div style={{ marginTop: "10px", color: "#9ca3af" }}>
    ⏳ Waiting for hunter assignment…
  </div>
)}


      {status.approved && !status.gameStarted && (
        <p>✅ Approved! Waiting for game start…</p>
      )}

      {status.gameStarted && (
        <p className="text-green-700">🚀 Game started — entering map…</p>
      )}

      {status.gameName && (
        <div style={{ marginTop: "10px" }}>
          <strong>Game:</strong> {status.gameName}
        </div>
      )}
    </div>
  );
}
